import { useParams } from "react-router-dom";
import { useStudentDetailsQuery } from "../../../../../hooks/useStudentDetailsQuery";
import { Box, Metadata, useTranslations } from "@bsm/component";
import { useMemo } from "react";

export const StudentEducationNeedsAndDisabilitiesContainer = () => {
    const { id } = useParams();
    const { data } = useStudentDetailsQuery(parseInt(id), true);
    const value = useMemo(() => data?.additionalEducationNeedsAndDisability, [data])
    const [
        EDUCATION_NEEDS_AND_DISABILITIES,
        ADDITIONNAL_LEARNING_NEEDS,
        SPECIALIZED_LEARNING,
    ] = useTranslations(i18nKeys);
    return (
        <div className="overflow-hidden rounded-3xl shadow bg-white">
            <Box title={EDUCATION_NEEDS_AND_DISABILITIES} className="flex flex-col gap-3 p-10">
                <Metadata className="[&_.metadata-label]:min-w-[250px] [&_.metadata-label]:max-w-[250px]" label={ADDITIONNAL_LEARNING_NEEDS} value={value?.hasAdditionalLearningNeeds ? value?.additionalLearningNeedsDescription : 'None'} />
                <Metadata className="[&_.metadata-label]:min-w-[250px] [&_.metadata-label]:max-w-[250px]" label={SPECIALIZED_LEARNING} value={value?.hasSpecializedLearning ? value?.specializedLearningDescription : 'None'} />
            </Box>
        </div>
    );
}
const i18nKeys = [
    "std_education_needs_and_disabilities",
    "std_additionnal_learning_needs",
    "std_specialized_learning",
];